/* Ensures only one floating sticky CTA is active at a time (priority + footer zone). */
(function () {
  "use strict";

  var MOBILE_MAX = 768;

  function isDisplayed(el) {
    if (!el || el.hidden) return false;
    var style = window.getComputedStyle(el);
    return style.display !== "none";
  }

  function wantsShow(el) {
    if (el.dataset.zeusStickyAlways === "mobile") {
      return window.matchMedia("(max-width: " + MOBILE_MAX + "px)").matches && isDisplayed(el);
    }
    return el.classList.contains("is-visible");
  }

  function nearFooter() {
    var footer = document.querySelector(
      "footer, .footer, #shopify-section-footer, .shopify-section--footer, .shopify-section-group-footer-group",
    );
    if (!footer) return false;
    return footer.getBoundingClientRect().top < window.innerHeight * 0.92;
  }

  function sync() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll("[data-zeus-sticky-cta]"));
    var footerNearby = nearFooter();

    var active = [];
    if (!footerNearby) {
      nodes.forEach(function (el) {
        if (!wantsShow(el)) return;
        active.push({
          el: el,
          priority: parseInt(el.getAttribute("data-zeus-sticky-priority") || "0", 10),
        });
      });
    }

    active.sort(function (a, b) {
      return b.priority - a.priority;
    });

    var winner = active.length ? active[0].el : null;
    nodes.forEach(function (el) {
      var shouldSuppress = footerNearby || (active.length > 0 && el !== winner && wantsShow(el));
      el.classList.toggle("is-suppressed", shouldSuppress);
    });
  }

  var rafPending = false;

  function scheduleSync() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () {
      rafPending = false;
      sync();
    });
  }

  window.ZeusStickyCtaCoordinator = { sync: sync };

  function init() {
    document.addEventListener("scroll", scheduleSync, { passive: true });
    window.addEventListener("resize", scheduleSync, { passive: true });

    var observer = new MutationObserver(scheduleSync);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class", "hidden"],
      subtree: true,
    });

    scheduleSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
